import React from "react";

import './SwitchYesItem.css';

const SwitchYesItem = (props) => {
    return (
        <div className="clsSwitchYes-item">
            <span className='clsSwitchYes-data-label'>{ props.label }:</span>
            <span className="clsSwitchYes-data-value">{ props.value }</span>
        </div>
    );
}

export default SwitchYesItem;